module.exports = __webpack_public_path__ + "static/media/paycargo_logo.a7356eb1.svg";